import { SideMenuDrawer } from './SideMenuDrawer';
import type { ReactNode } from 'react';
import { NAV_COLLAPSED_WIDTH, NAV_EXPANDED_WIDTH } from '../../../../shared/constants';
import theme from '../../../../theme/theme';

interface DesktopSideMenuProps {
  open: boolean;
  hovering?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children: ReactNode;
}

const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';

export default function DesktopSideMenu({
  open,
  hovering = false,
  onMouseEnter,
  onMouseLeave,
  children,
}: DesktopSideMenuProps) {
  const effectiveExpanded = open || hovering;
  const containerWidth = open ? NAV_EXPANDED_WIDTH : NAV_COLLAPSED_WIDTH;

  return (
    <SideMenuDrawer
      variant="permanent"
      open={effectiveExpanded}
      drawerWidth={containerWidth}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      paperSx={
        !open
          ? {
              overflowX: 'hidden',
              position: 'fixed',
              zIndex: theme.zIndex.drawer + 1,
              width: hovering ? NAV_EXPANDED_WIDTH : NAV_COLLAPSED_WIDTH,
              boxShadow: hovering ? theme.shadows[8] : 'none',
              transition: `width 300ms ${EASE}, box-shadow 300ms ${EASE}`,
              '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
            }
          : { overflowX: 'hidden' }
      }
    >
      {children}
    </SideMenuDrawer>
  );
}
